"use client";

import { Box, Typography } from "@mui/material";
import React from "react";
import { useCurrencyCode } from "../../genericComponents/helper-functions/CurrencySymbol";
import { OrderBreakdown } from "./OrderBreakdown";

interface PaymentSummeryDesktopViewProps {
  cart: any;
}

export const PaymentSummeryDesktopView: React.FC<
  PaymentSummeryDesktopViewProps
> = ({ cart }) => {
  const currencyCode = useCurrencyCode();

  return (
    <Box sx={{ width: "100%" }}>
      <Typography
        variant="h6"
        sx={{
          pb: 1,
          fontWeight: 800,
          textAlign: "left",
          letterSpacing: "-0.03em",
          color: "#0b1710",
          fontSize: "1.05rem",
        }}
      >
        Price details
      </Typography>
      <Typography
        variant="caption"
        sx={{
          display: "block",
          color: "text.secondary",
          mb: 2,
          lineHeight: 1.45,
        }}
      >
        Subtotal, discount, delivery, and your total before you choose a slot.
      </Typography>
      <OrderBreakdown
        cart={cart}
        currencyCode={currencyCode}
        variant="desktop"
      />
    </Box>
  );
};
